import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { AuthGuard } from '@core/services/guards/auth.guard';
import { TokenManager } from '@core/services/tokens/token-manager';
import { ROUTER_CONFIG } from '@core/utils/configs';

const routes: Routes = [
  {
    path: 'auth',
    canActivate: [() => TokenManager.isExpired()],
    loadChildren: () => import('@pages/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'terminos-y-condiciones',
    loadChildren: () => import('@pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule)
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    resolve: { app: () => inject(AuthService).resolve() },
    loadChildren: () => import('@pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'recatpcha-movil',
    loadChildren: () => import('@pages/recatpcha-mobile/recatpcha-mobile.module').then(m => m.RecatpchaMobileModule)
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, ROUTER_CONFIG)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
